import * as React from 'react';
import { useGetProviderUserQuery } from "../../../apis/ProviderUser.api";
import { PrimaryProviderUser, ProviderUser } from "../../../types/models/ProviderUser";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: ProviderUser;
};

export const ProviderUserNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.email }
                    {data?.name && <> | </> }{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ProviderUserName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetProviderUserQuery(PrimaryProviderUser.fromId(id))
    return (<ProviderUserNameDisplay data={data}/>)
}

export default ProviderUserName;
